import { Fragment } from 'react';

import { SkeletonBlock } from '../../../../components/ToolkitV2/Skeleton/Skeleton';

import { Spacer } from '../../../../helpers/genericStyles';

export const SkeletonInputs = (props: { arrayLength: number }) => {
  const { arrayLength } = props;

  return (
    <>
      {Array(arrayLength)
        .fill(null)
        .map((_item: null, index: number) => {
          const key = `skeleton-input-${index}`;
          return (
            <Fragment key={key}>
              <SkeletonBlock w="126px" h="32px" />
              <Spacer marginBottom="S8" />
              <SkeletonBlock w="100%" h="32px" />
              <Spacer marginBottom="M32" />
            </Fragment>
          );
        })}
    </>
  );
};
